import { render } from "./Repair_button.vue?vue&type=template&id=4bcdfb4c&scoped=true"
import script from "./Repair_button.vue?vue&type=script&lang=js"
export * from "./Repair_button.vue?vue&type=script&lang=js"

import "./Repair_button.vue?vue&type=style&index=0&id=4bcdfb4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bcdfb4c"]])

export default __exports__